import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { getAuth, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { collection, query, where, getDocs } from 'firebase/firestore';
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import './lecturerpanel.css';
import emailjs from "emailjs-com";
import { db } from './firebase'; // Adjust path as needed
import { storage } from "./firebase"; 


import { v4 as uuidv4 } from "uuid"; // Import uuid for generating unique IDs
import { uploadBytes } from 'firebase/storage'; // Modular imports
import { addDoc } from "firebase/firestore";



const LecturerDashboard = () => {
  const [selectedOption, setSelectedOption] = useState("home"); // Default to "home"
  const [userDetails, setUserDetails] = useState(null); // Store user details
  const auth = getAuth(); // Initialize Firebase Auth
  const navigate = useNavigate(); // Initialize navigate
  const db = getFirestore(); // Initialize Firestore
  const [messageType, setMessageType] = useState("inquiry");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
    const [lecturerEmail, setLecturerEmail] = useState("");


  // State variables
  const [loading, setLoading] = useState(false); // For loading indicator
  const [assignments, setAssignments] = useState([]); // For storing fetched assignments



  // Fetch current user details ////////////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          const userRef = doc(db, "users", user.uid); // Assuming user details are stored in "users" collection in Firestore
          const userSnap = await getDoc(userRef);
          
          if (userSnap.exists()) {
            setUserDetails(userSnap.data());
          } else {
            console.log("No user data found!");
          }
        } catch (error) {
          console.error("Error fetching user details: ", error);
        }
      }
    };
    fetchUserDetails();
  }, [auth, db]);



    
      // Logout function////////////////////////////////////////////////////////////////////////////////////////////////////////
      const handleLogout = async () => {
        try {
          await signOut(auth); // Call signOut from Firebase Auth
        //   alert("Logged out successfully!");
          navigate("/login"); // Navigate to login page
        } catch (error) {
          console.error("Error logging out:", error.message);
        //   alert("Logout failed. Please try again.");
        }
      };









  // Fetch the logged-in user's email  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      setLecturerEmail(user.email);
    }
  }, [auth.currentUser]);

      // Handle Send Message with EmailJS
  const handleSend = (e) => {
    e.preventDefault();

    const templateParams = {
      lecturer_email: lecturerEmail, // Sender's email
      message_type: messageType, // Selected message type
      subject, // Subject of the message
      message, // Message body
    };

    emailjs
      .send(
        "service_gahawkc", // Replace with your EmailJS service ID
        "template_tz75vnj", // Replace with your EmailJS template ID
        templateParams,
        "SmoVT3u-6A8Q9aI9_" // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          handleClear(); // Clear the form after sending
        },
        (error) => {
          console.error("Failed to send message:", error);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  // Handle Clear Form
  const handleClear = () => {
    setMessageType("inquiry");
    setSubject("");
    setMessage("");
  };




//fetch assignments to download
// const fetchAssignments = async () => {
//   setLoading(true);
//   try {
//     const querySnapshot = await getDocs(collection(db, "assignmentSubmissionDetails"));
//     const fetchedAssignments = querySnapshot.docs.map((doc) => ({
//       ...doc.data(),
//       id: doc.id,
//     }));
//     setAssignments(fetchedAssignments);
//   } catch (error) {
//     console.error("Error fetching assignments:", error);
//     alert("Failed to fetch assignments.");
//   } finally {
//     setLoading(false);
//   }
// };

// useEffect(() => {
//   if (selectedOption === "downloadAssignment") {
//     fetchAssignments();
//   }
// }, [selectedOption]);



// // Function to fetch assignment details from Firestore and the actual files from Firebase Storage
// const fetchAssignments = async () => {
//   setLoading(true);

//   try {
//     const querySnapshot = await getDocs(collection(db, "assignmentSubmissionDetails"));
//     const fetchedAssignments = [];

//     // Fetching assignment details from Firestore
//     for (const doc of querySnapshot.docs) {
//       const assignmentData = doc.data();
//       const moduleFolderRef = ref(getStorage(), `assignments/${assignmentData.moduleCode}`);
      
//       // Fetch files in the corresponding module folder in Storage
//       const filesSnapshot = await listAll(moduleFolderRef);
      
//       const fileLinks = await Promise.all(filesSnapshot.items.map(async (fileRef) => {
//         const fileUrl = await getDownloadURL(fileRef);
//         return { name: fileRef.name, url: fileUrl }; // Create file download link
//       }));

//       // Adding the fetched files to the assignment data
//       fetchedAssignments.push({
//         ...assignmentData,
//         id: doc.id,
//         files: fileLinks, // Store the file links for this assignment
//       });
//     }

//     setAssignments(fetchedAssignments);
//   } catch (error) {
//     console.error("Error fetching assignments:", error);
//     alert("Failed to fetch assignments.");
//   } finally {
//     setLoading(false);
//   }
// };

// useEffect(() => {
//   if (selectedOption === "downloadAssignment") {
//     fetchAssignments();
//   }
// }, [selectedOption]);













//////////////// State management  ////////////////////////////////////////////////////////////////////////////////////////////////////////

const [studentSubmissions, setStudentSubmissions] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [filters, setFilters] = useState({
  batch: '',
  moduleCode: '',
  viewType: 'all' // 'all', 'assignments', or 'submissions'
});
const [availableBatches, setAvailableBatches] = useState([]);
const [availableModules, setAvailableModules] = useState([]);

// Fetch data from both collections
const fetchAllData = async () => {
  setLoading(true);
  try {
    // Fetch teacher assignments
    const assignmentsSnapshot = await getDocs(collection(db, "assignmentSubmissionDetails"));
    const fetchedAssignments = [];
    
    // Fetch student submissions
    const submissionsSnapshot = await getDocs(collection(db, "assignmentStudentDetails"));
    const fetchedSubmissions = [];
    
    const batches = new Set();
    const modules = new Set();

    // Process teacher assignments
    for (const doc of assignmentsSnapshot.docs) {
      const assignmentData = doc.data();
      batches.add(assignmentData.batch);
      modules.add(assignmentData.moduleCode);

      // Get files from Storage if needed
      const moduleFolderRef = ref(storage, `assignments/${assignmentData.moduleCode}`);
      const filesSnapshot = await listAll(moduleFolderRef);
      const fileLinks = await Promise.all(filesSnapshot.items.map(async (fileRef) => {
        const fileUrl = await getDownloadURL(fileRef);
        return { name: fileRef.name, url: fileUrl };
      }));

      fetchedAssignments.push({
        ...assignmentData,
        id: doc.id,
        type: 'assignment',
        files: fileLinks,
      });
    }

    // Process student submissions
    for (const doc of submissionsSnapshot.docs) {
      const submissionData = doc.data();
      batches.add(submissionData.batch);
      modules.add(submissionData.moduleCode);

      fetchedSubmissions.push({
        ...submissionData,
        id: doc.id,
        type: 'submission',
        files: submissionData.downloadURL ? [{
          name: submissionData.fileName,
          url: submissionData.downloadURL
        }] : []
      });
    }

    setAssignments(fetchedAssignments);
    setStudentSubmissions(fetchedSubmissions);
    setAvailableBatches(Array.from(batches));
    setAvailableModules(Array.from(modules));
    applyFilters(fetchedAssignments, fetchedSubmissions);

  } catch (error) {
    console.error("Error fetching data:", error);
    alert("Failed to fetch data.");
  } finally {
    setLoading(false);
  }
};





// Apply filters to both datasets
const applyFilters = (assignmentsData = assignments, submissionsData = studentSubmissions) => {
  let filteredAssignments = [...assignmentsData];
  let filteredSubmissions = [...submissionsData];
  
  // Apply batch filter
  if (filters.batch) {
    filteredAssignments = filteredAssignments.filter(item => item.batch === filters.batch);
    filteredSubmissions = filteredSubmissions.filter(item => item.batch === filters.batch);
  }
  
  // Apply module filter
  if (filters.moduleCode) {
    filteredAssignments = filteredAssignments.filter(item => item.moduleCode === filters.moduleCode);
    filteredSubmissions = filteredSubmissions.filter(item => item.moduleCode === filters.moduleCode);
  }
  
  // Combine based on view type
  let result = [];
  switch (filters.viewType) {
    case 'assignments':
      result = filteredAssignments;
      break;
    case 'submissions':
      result = filteredSubmissions;
      break;
    default:
      result = [...filteredAssignments, ...filteredSubmissions];
  }
  
  setFilteredData(result);
};

const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({
    ...prev,
    [name]: value
  }));
};

const resetFilters = () => {
  setFilters({
    batch: '',
    moduleCode: '',
    viewType: 'all'
  });
  setFilteredData([...assignments, ...studentSubmissions]);
};

useEffect(() => {
  fetchAllData();
}, []);

useEffect(() => {
  applyFilters();
}, [filters, assignments, studentSubmissions]);








//upload lecture materials

//pdf upload
const [selectedFile, setSelectedFile] = useState(null);
const [file, setFile] = useState(null);
const [id, setId] = useState('');
const [error, setError] = useState(null);  // Initialize the error state
const [moduleCode, setModuleCode] = useState('');
const [moduleName, setModuleName] = useState('');
const [batch, setBatch] = useState('');

//upload pdf
  // Handle file selection
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      setError('');
    } else {
      setError("Please select a valid PDF file.");
    }
  };

  // Handle form submission and file upload
  const uploadFile = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      setError("No file selected.");
      return;
    }

    if (!batch || !id || !moduleCode || !moduleName) {
      setError("Please fill in all the fields.");
      return;
    }

    setLoading(true);

    try {
      // Generate a unique file name using UUID
      const uniqueFileName = `${uuidv4()}_${selectedFile.name}`;

      // Upload the file to Firebase Storage with a unique file name
      const storageRef = ref(storage, `pdfs/${uniqueFileName}`);
      await uploadBytes(storageRef, selectedFile);

      // Get the download URL
      const fileUrl = await getDownloadURL(storageRef);
      console.log("File uploaded successfully:", fileUrl);

      // Optionally, store the file URL and other data in Firestore
      // Store multiple PDFs under the same 'id' using addDoc to create a new document each time
      await addDoc(collection(db, "materials"), {
        batch,
        id,
        moduleCode,
        moduleName,
        fileUrl,
      });

      setLoading(false);
      alert("File uploaded successfully!");
    } catch (err) {
      console.error("Upload error:", err);
      setError(`Error uploading file: ${err.message || err}`);
      setLoading(false);
    }
  };








  return (
    <div className="student-dashboard-container">


         {/* <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div>

          <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div> */}

       {/* Left Sidebar */}
        <div className="lecturer-sidebar">
        <h2 className="lecturer-sidebar-title">Lecturer Panel</h2>
        <div className="lecturer-sidebar-list">
            <li onClick={() => setSelectedOption("home")}>Home</li>
            <li onClick={() => setSelectedOption("viewMyProfile")}>View My Profile</li>
            <li onClick={() => setSelectedOption("courseGuidlines")}>Course awareness</li>
            <li onClick={() => setSelectedOption("downloadAssignment")}>Download Assignments</li>
            <li onClick={() => setSelectedOption("uploadMaterial")}>Upload Lecture Materials</li>
            {/* <li onClick={() => setSelectedOption("placementReport")}>Student Placement Report</li> */}
            <li onClick={() => setSelectedOption("contactAdmin")}>Contact Admin</li>
            <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
        </div>
        {/* Main Panel */}
        <div className="lecturer-panel">
                {selectedOption === "home" && (
                <div className="home-section">
                    <div className="home-content">
                    <img
                        src="/logo.jpg" // Assuming the image is in the public folder
                        alt="Eye Care Institute"
                        className="home-image"
                    />
                    <p className="home-description">
             We are a leading non-state higher education institute, approved by the Ministry of Education and accredited 
             by the Tertiary & Vocational Education Commission (TVEC). Additionally, we are members of the World Council of Optometry (WCO) 
             and the Asia Pacific Council of Optometry (APCO). Our Optician and Optometry courses are recognized by the Ceylon Council of
             Optometrists & Orthoptists (CCOO), Sri Lanka. ECI is the first Sri Lankan private institute to be recognized by the 
             Government of Sri Lanka. We are the only Optometry institute affiliated with a university.
                    </p>
                    </div>

                    <div className="vision-mission">
                    <div className="vision">
                        <h2>Our Vision</h2>
                        <p>
                        To be the leader in professional eye care organization by improving the quality
                        and quantity of the service providers in all eye care segments in the region.
                        </p>
                    </div>

                    <div className="mission">
                        <h2>Our Mission</h2>
                        <p>
                        Improve the quality of life in the region by integrating, sharing, and enhancing
                        experience and innovation with professionals involved in eye care.
                        </p>
                    </div>
                    </div>
                </div>
                )}

{/* {selectedOption === "placementReport" && 
                <div>
                  <h1 className="lecturer-awareness-title">Student Placement Report</h1>
                  <p className="lecturer-awareness-description">
                    Student Placement Report!
                  </p>
                  <div className="guidelines-downloads">
                    <ul>
                      <li>
                        <a href="/placementreport.doc" download>
                          Download Student Placement Report
                          <span className="file-type">(PDF)</span>
                        </a>
                      </li>
                     

                    </ul>
                  </div>
                </div>
              } */}
      
{/************************************************************************************************************************/} 
              {selectedOption === "viewMyProfile" && userDetails && (
                <div className="profile-container">


                  {/* Profile Title */}
                  <h2>My Profile</h2>

                  {/* Profile Details */}
                  <div className="profile-info">
                    <p><strong>Name:</strong> {userDetails.firstName} {userDetails.lastName}</p>
                    <p><strong>Email:</strong> {auth.currentUser.email}</p>
                    <p><strong>NIC / Passport:</strong> {userDetails.nicPassport}</p>
                    <p><strong>Role:</strong> {userDetails.role}</p>
                    <p><strong>Program:</strong> {userDetails.program}</p>
                    <p><strong>Address:</strong> {userDetails.address}</p>
                    <p><strong>Contact:</strong> {userDetails.contactNo}</p>
                  </div>
                            
                    <img
                    src={`${process.env.PUBLIC_URL}/imglock.png`} // Update with actual image source
                    alt="Profile"
                    className="profile-image"
                  />

                </div>
              )}

{/************************************************************************************************************************/} 
        
              {selectedOption === "courseGuidlines" && 
                <div>
                  <h1 className="lecturer-awareness-title">Course Awareness</h1>
                  <p className="lecturer-awareness-description">
                    Review guidelines, policies, and best practices for your academic role.
                  </p>
                  <div className="guidelines-downloads">
                    <ul>
                      <li>
                        <a href="/co-syllabus.pdf" download>
                          Download Syllabus of Certificate in Optician 
                          <span className="file-type">(PDF)</span>
                        </a>
                      </li>
                      <li>
                        <a href="/do-syllabus.pdf" download>
                          Download Syllabus of Diploma in Optometry 
                          <span className="file-type">(PDF)</span>
                        </a>
                      </li>
                      <li>
                        <a href="/co-evaluation-scheme.pdf" download>
                          Download Evaluation Scheme of Certificate in Optician 
                          <span className="file-type">(PDF)</span>
                        </a>
                      </li>

                    </ul>
                  </div>
                </div>
              }












{/************************************************************************************************************************/} 


            {selectedOption === "uploadMaterial" && (
              <div className="upload-material-container">
                <h1>Upload Lecture Material</h1>

                {/* File upload form */}
                <form onSubmit={uploadFile}>
                <select
              className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
                  <div>
                    <label>Course</label>
                    <select
                    className="admin-panel-select"
                      type="text"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      placeholder="CO / DO / HDO"
                    >
                      <option value="">Select Course</option>
                      <option value="CO">Certificate in Optician</option>
                      <option value="DO">Diploma in Optometry</option>
                       <option value="HDO">Higher Diploma in Optometry</option>
                      </select>
                  </div>



 <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Understanding Prescription & Ocular Measurement - CO104</option>
                <option value="CO105">Ophthalmic Lens & Frame - CO105</option>
                <option value="CO201">Common Eye Diseases - CO201</option>
                <option value="CO202">Clinical Optics & Refraction - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Pharmacology - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO307">Dispensing Optics - DO307</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

            {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="HDO101">General Anatomy & Physiology - HDO101</option>
                <option value="HDO102">General & Ocular Microbiology - HDO102</option>
                <option value="HDO103">Biochemistry - HDO103</option>
                <option value="HDO104">Optics- Geometrical& Physical - 	HDO104</option>
                <option value="HDO105">Ocular anatomy & Physiology - HDO105</option>
                <option value="HDO201">Ocular pathology I - HDO201</option>
                <option value="HDO202">Clinical procedure I - HDO202</option>
                <option value="HDO203">Visual optics - HDO203</option>
                <option value="HDO204">Pharmacology - HDO204</option>
                <option value="HDO205">Physiology of vision - HDO205</option>
                <option value="HDO206">General Medicine - HDO206</option>
                <option value="HDO301">Clinical procedure II - HDO301</option>
                <option value="HDO302">Ocular pathology II - HDO302</option>
                <option value="HDO303">Binocular Vision - HDO303</option>
                <option value="HDO304">Contact lens - HDO304</option>
                <option value="HDO305">Geriatric & Paediatric Optometry - HDO305</option>
                <option value="HDO306">Low Vision - HDO306</option>
                <option value="HDO307">Dispensing Optics - HDO307</option>
                <option value="HDO401">Public Health & Community Optometry - HDO401</option>
                <option value="HDO402">Occupational Optometry - HDO402</option>
                <option value="HDO403">Practice Management - HDO403</option>
                <option value="HDO404">Research Methodology & Professional Ethics - HDO404</option>
              </>
            )}
          </select>
        </div>

        <div>
          <label>Module Name</label>
          <input
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          />
            {/* <option value="">Select Module</option>
            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical& Physical">Optics- Geometrical& Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </> 
            )}*/}
      
        </div>



                  <div>
                    <label>Choose file</label>
                    <input type="file" onChange={handleFileSelect} />
                  </div>
                  {error && <p>{error}</p>}
                  <button type="submit" disabled={loading}>
                    {loading ? "Uploading..." : "Upload Material"}
                  </button>
                </form>
              </div>
            )}



    
{/****************************************************************************************************************************************/}

        {selectedOption === "contactAdmin" && (
          <>
            <h1 className="lecturer-panel-title">Contact Admin</h1>
            <form className="contact-form" onSubmit={handleSend}>
              <label className="form-label">Your Email</label>
              <input
                type="email"
                value={lecturerEmail}
                readOnly
                className="form-input read-only"
              />

              <label className="form-label">Message Type</label>
              <select
                value={messageType}
                onChange={(e) => setMessageType(e.target.value)}
                className="form-input"
              >
                <option value="inquiry">Inquiry</option>
                <option value="request">Request</option>
                <option value="complaint">Complaint</option>
              </select>

              <label className="form-label">Subject</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Enter subject"
                className="form-input"
                required
              />

              <label className="form-label">Message</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Write your message here"
                className="form-textarea"
                required
              ></textarea>

              <div className="form-buttons">
                <button type="button" className="clear-button" onClick={handleClear}>
                  Clear
                </button>
                <button type="submit" className="send-button">
                  Send
                </button>
              </div>
            </form>
          </>
        )}



{/* {selectedOption === "downloadAssignment" && (
        <div className="lecturer-panel-container">
          <h1>Submitted Assignments</h1>
          {loading ? (
            <p>Loading submissions...</p>
          ) : assignments.length > 0 ? (
            <table className="submission-table">
              <thead>
                <tr>
                  <th>Batch</th>
                  <th>Module Code</th>
                  <th>Module Name</th>
                  <th>Submission Deadline</th>
                  <th>Download Links</th>
                </tr>
              </thead>
              <tbody>
                {assignments.map((assignment, index) => (
                  <tr key={index}>
                    <td data-label="Batch">{assignment.batch}</td>
                    <td data-label="Module Code">{assignment.moduleCode}</td>
                    <td data-label="Module Name">{assignment.moduleName}</td>
                    <td data-label="Submission Deadline">
                      {assignment.submissionDeadline && assignment.submissionDeadline.toDate
                        ? new Date(assignment.submissionDeadline.toDate()).toLocaleString()
                        : "Invalid Deadline"}
                    </td>
                    <td data-label="Download Links">
                      {assignment.files.length > 0 ? (
                        <ul>
                          {assignment.files.map((file, idx) => (
                            <li key={idx}>
                              <a
                                href={file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="download-link"
                              >
                                {file.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>No submissions for this module.</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No assignment submissions found.</p>
          )}
        </div>
      )}
          */}



{/************************************************************************************************************************/} 


 
{selectedOption === "downloadAssignment" && (
  <div className="lecturer-panel-container">
    <h1>Submitted Assignments</h1>
    
    <div className="filter-controls">
      <div className="filter-group">
        <label htmlFor="batch-filter">Filter by Batch:</label>
        <select
          id="batch-filter"
          name="batch"
          value={filters.batch}
          onChange={handleFilterChange}
        >
          <option value="">All Batches</option>
          {availableBatches.map(batch => (
            <option key={batch} value={batch}>{batch}</option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label htmlFor="module-filter">Filter by Module:</label>
        <select
          id="module-filter"
          name="moduleCode"
          value={filters.moduleCode}
          onChange={handleFilterChange}
        >
          <option value="">All Modules</option>
          {availableModules.map(module => (
            <option key={module} value={module}>{module}</option>
          ))}
        </select>
      </div>
      



      
      <button onClick={resetFilters} className="reset-btn">
        Reset Filters
      </button>
    </div>

    {loading ? (
      <p>Loading submissions...</p>
    ) : filteredData.length > 0 ? (
      <table className="submission-table">
        <thead>
          <tr>
            {/* <th>Type</th> */}
            <th>Batch</th>
            <th>Module Code</th>
            <th>Module Name</th>
            {/* {filters.viewType !== 'assignments' && <th>Student Name</th>} */}
            {/* {filters.viewType !== 'assignments' && <th>Reg. Number</th>} */}
            {/* <th>Deadline</th> */}
            {/* {filters.viewType !== 'assignments' && <th>Submitted</th>} */}
            <th>Files</th>
            {/* {filters.viewType !== 'assignments' && <th>Status</th>} */}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item, index) => (
            <tr key={index} className={`${item.type}-row`}>
              {/* <td data-label="Type">
                {item.type === 'assignment' ? 'Assignment' : 'Submission'}
              </td> */}
              <td data-label="Batch">{item.batch}</td>
              <td data-label="Module Code">{item.moduleCode}</td>
              <td data-label="Module Name">{item.moduleName}</td>
              
              {/* {filters.viewType !== 'assignments' && (
                <td data-label="Student Name">
                  {item.type === 'submission' ? item.name : '-'}
                </td>
              )}
              
              {filters.viewType !== 'assignments' && (
                <td data-label="Reg. Number">
                  {item.type === 'submission' ? item.registrationNumber : '-'}
                </td>
              )} */}
              
              {/* <td data-label="Deadline">
                {item.submissionDeadline && item.submissionDeadline.toDate
                  ? new Date(item.submissionDeadline.toDate()).toLocaleString()
                  : "N/A"}
              </td>
               */}
              {/* {filters.viewType !== 'assignments' && (
                <td data-label="Submitted">
                  {item.type === 'submission' && item.submissionTime
                    ? new Date(item.submissionTime).toLocaleString()
                    : '-'}
                </td>
              )} */}
              
              <td data-label="Files">
                {item.files && item.files.length > 0 ? (
                  <ul>
                    {item.files.map((file, idx) => (
                      <li key={idx}>
                        <a
                          href={file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="download-link"
                          download
                        >
                          {file.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No files</p>
                )}
              </td>
{/*               
              {filters.viewType !== 'assignments' && (
                <td data-label="Status">
                  {item.type === 'submission' ? (item.status || 'Submitted') : '-'}
                </td>
              )} */}
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p>No data found matching your filters.</p>
    )}
  </div>
)}







        </div>
    </div>



  );
};

export default LecturerDashboard;
